<script setup>
import { fireEvent } from "~/composables/events";

definePageMeta({
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: "/profile",
  },
  layout: "guest",
});

const title = ref("Carta Fedeltà Prénatal - Tutti i vantaggi");
const description = ref(
  "Acquista la tua VIP Card e unisciti al Club Prenatal: ti aspettano offerte esclusive, sconti riservate e tanti altri vantaggi. Inizia oggi a risparmiare!"
);

function fireRegisterEvent() {
  fireEvent("start_registration");
}
const showAssistant = ref(null)

function closeAssistant() {
  showAssistant.value = false
  if (process.client) {
    sessionStorage.setItem('assistantClosed', 'true')
  }
}

onMounted(() => {
  if (process.client) {
    const closed = sessionStorage.getItem('assistantClosed')
    showAssistant.value = closed === 'true' ? false : true
  }
})
</script>
<template>
  <Title>{{ title }}</Title>
  <Meta name="description" :content="description" />

  <div class="container px-5 pt-6 md:pt-14">
    <HomepageTopBanner
      @register-event="fireRegisterEvent"
      class="hidden relative md:block"
    />
    <HomepageTopBannerMobile
      @register-event="fireRegisterEvent"
      class="md:hidden block"
    />
    <HomepageAdvantagesOfClubSection />
  </div>

  <HomepageBenefitsSection />

  <HomepageReviews />

  <HomepageListaNacitaSection />

  <HomepageLoginBanner />

  <!-- <Transition name="fade">
    <div v-if="showAssistant" class="fixed bottom-10 right-10">
      <button
        @click="closeAssistant"
        class="absolute -top-5 -right-5 m-1 bg-white rounded-full w-6 h-6 flex items-center justify-center text-black font-bold shadow"
        aria-label="Close assistant button"
      >
        ×
      </button>

      <nuxt-link
        class="rounded-full p-px w-14 md:w-20 mx-auto bg-cerise-red-600 overflow-hidden block"
        to="/assistant"
      >
        <img
          referrerpolicy="no-referrer"
          alt="Lisa"
          src="https://bucket.heres.ai/prenatal/chat-configs/k2qM4VjHJZoALQZ8AdBQHC.png"
        />
      </nuxt-link>
    </div>
  </Transition> -->
</template>
